import { faFileExcel, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView } from '@uirouter/react';
import { Button, Space } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_CREATE, PERMISSION_OBJ_FARMER } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { farmerStore } from '@/stores';
import { getGenericFilters, toQueryFormat } from '@/components/table/utils';

import { columns } from './setup';

const store = farmerStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_FARMER, PERMISSION_CREATE]])(
  ({ onClick, icon, messageId }: any) => {
    return (
      <Button onClick={onClick} type="primary" icon={<FontAwesomeIcon icon={icon} />}>
        &nbsp;&nbsp;
        <FormattedMessage id={messageId} />
      </Button>
    );
  },
);

export const Farmers = observer(({ transition }: any) => {
  const items = store.items;

  useEffect(() => {
    store.forceLoad({ sort: 'id:-1' });
  }, []);

  const genericFilters = useMemo(() => getGenericFilters(columns), []);

  const onChangeTable = (...args) => {
    const params = toQueryFormat.apply(null, [genericFilters, ...args]);
    store.forceLoad(params);
  };

  const onAdd = () => {
    transition.router.stateService.go(`base-layout.farmers.create`);
  };

  const onCreateFromExcel = () => {
    transition.router.stateService.go(`base-layout.farmers.create-from-excel-by-type`);
  };

  const onRow = (record: cyrian.api.farmers.Farmer) => ({
    onClick: () => transition.router.stateService.go('base-layout.farmers.view', { farmerId: record.id }),
    className: 'table-row-cursor',
  });

  return (
    <>
      <Space>
        <CreateButton onClick={onAdd} icon={faPlus} messageId="farmers.add-new" />
        <CreateButton onClick={onCreateFromExcel} icon={faFileExcel} messageId="farmers.create-from-excel-by-type" />
      </Space>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={[...items]}
        store={store}
        onRow={onRow}
        onChange={onChangeTable}
      />
      <UIView />
    </>
  );
});
